export default __webpack_public_path__ + "static/media/brand-8.c6b6ce87.png";